var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[(_vm.mensagem)?_c('b-alert',{attrs:{"dismissible":"","show":"","variant":_vm.mensagem.tipo}},[_vm._v(" "+_vm._s(_vm.mensagem.mensagem)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }